import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=3cad4288"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"
import style0 from "./follow.vue?vue&type=style&index=0&id=3cad4288&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cad4288')) {
      api.createRecord('3cad4288', component.options)
    } else {
      api.reload('3cad4288', component.options)
    }
    module.hot.accept("./follow.vue?vue&type=template&id=3cad4288", function () {
      api.rerender('3cad4288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flow/follow.vue"
export default component.exports